export default "__VITE_ASSET__c2f8b9cf__"